module.exports = __webpack_public_path__ + "img/3_87.bee478c4.png";